import { getRandomInt } from '@/utilities';

export default class VerifyBug {
  constructor(reference) {
    this.reference = reference;
  }

  verify() {
    if (this.reference.task.isVerified || getRandomInt(1, 10) > 3) {
      this.reference.task.verify();
      this.reference.emptyTask();
      return;
    }
    this.reference.task.setBugNotPass();
    this.reference.placeTask();
  }
}
